import React from 'react'
import {
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core'
import { useRoutes } from 'hooks'
import { CHAT_PATH, HOME_PATH } from 'routes/constants.routes'
import { ArrowLeftIcon, ChevronDownIcon } from 'asterX-UIkit/Icons'
import { useRequestStyles } from './request.styles'
import { useHomeStore } from 'context/HomeStore'
import InfoCard from './components/InfoCard/InfoCard'
import { getStatusText } from 'constants/constants'
import ChatCard from './components/ChatCard/ChatCard'
import FileCard from './components/FileCard/FileCard'
import { LoaderBackdrop } from 'asterX-UIkit/Loaders'
import ReviewModal from './components/Modals/ReviewModal/ReviewModal'
import RenewModal from './components/Modals/RenewModal/RenewModal'

const renderAccordion = (title, ContentComponent) => (
  <Accordion
    style={{ border: '1px solid #EAECF0', marginTop: 16, padding: '0px 12px' }}
  >
    <AccordionSummary expandIcon={<ChevronDownIcon />}>
      <Typography style={{ fontSize: 14, fontWeight: 600 }}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <ContentComponent isMobile />
    </AccordionDetails>
  </Accordion>
)

const RequestPage = () => {
  const classes = useRequestStyles()
  const router = useRoutes()
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'))

  const {
    homeStore: { requestList, loading, openReviewModal, openRenewModal },
    homeStoreFunc: { setOpenReviewModal, setOpenRenewModal }
  } = useHomeStore()

  const getStatusVariant = status => {
    switch (status) {
      case 'Завершен':
        return 'outlined'
      case 'Отменен':
        return 'contained'
      case 'Отказан':
        return 'contained'
      default:
        return ''
    }
  }

  const getButtonText = status => {
    switch (status) {
      case 'Завершен':
        return 'Оставить отзыв'
      case 'Отменен':
        return 'Возобновить заявку'
      case 'Отказан':
        return 'Возобновить заявку'
      default:
        return ''
    }
  }

  const handleButtonClick = status => {
    if (['Завершен', 'Отменен'].includes(status)) {
      setOpenReviewModal(prev => !prev)
    }
    if (['Отказан', 'Отменен'].includes(status)) {
      setOpenRenewModal(prev => !prev)
    }
  }

  const isDisabled = () => {
    return (
      loading ||
      (['Завершен'].includes(requestList.status) &&
        requestList.hadQuestionnaire)
    )
  }

  const handleChatClick = id => {
    router.goTo(`${CHAT_PATH}/${id}`)
  }

  return (
    <Container style={{ marginBottom: 50 }}>
      <LoaderBackdrop loading={loading} />
      <Grid item xs={12} style={{ marginBottom: 16, marginTop: 32 }}>
        <Button style={{ padding: 0 }} onClick={() => router.goTo(HOME_PATH)}>
          <ArrowLeftIcon />
          Назад
        </Button>
      </Grid>
      <Grid
        item
        container
        md={12}
        direction={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
      >
        <Grid
          item
          container
          md={6}
          direction="column"
          spacing={2}
          style={{ paddingLeft: 8 }}
        >
          <Typography className={classes.title}>
            Заявка №{requestList.id}
          </Typography>
          <Typography className={classes.subtitle}>
            {getStatusText(requestList.status)}
          </Typography>
        </Grid>
        {['Завершен', 'Отменен', 'Отказан'].includes(requestList.status) && (
          <Grid item container md={6} justifyContent="flex-end">
            <Button
              variant={getStatusVariant(requestList.status)}
              color="primary"
              disabled={isDisabled()}
              onClick={() => handleButtonClick(requestList.status)}
              style={{
                height: 40,
                padding: '10px 14px',
                width: isMobile ? '100%' : 'auto',
                marginTop: isMobile ? 12 : 0
              }}
            >
              {getButtonText(requestList.status)}
            </Button>
          </Grid>
        )}
      </Grid>
      <Grid item container spacing={isMobile ? 0 : 5}>
        {isMobile ? (
          <>
            <Grid item xs={12}>
              <Accordion
                style={{
                  border: '1px solid #EAECF0',
                  marginTop: 16,
                  padding: '0px 12px'
                }}
                onClick={() => handleChatClick(requestList?.id)}
              >
                <AccordionSummary expandIcon={<ChevronDownIcon />}>
                  <Typography style={{ fontSize: 14, fontWeight: 600 }}>
                    Чат с поддержкой
                  </Typography>
                </AccordionSummary>
              </Accordion>
            </Grid>
            <Grid item xs={12}>
              {renderAccordion('Информация о заявке', InfoCard)}
            </Grid>
            <Grid item xs={12}>
              {renderAccordion('Прикрепленные файлы', FileCard)}
            </Grid>
          </>
        ) : (
          <>
            <Grid item md={6}>
              <Paper className={classes.border}>
                <InfoCard />
              </Paper>
              <Paper className={classes.border}>
                <FileCard />
              </Paper>
            </Grid>
            <Grid item md={6}>
              <Paper className={`${classes.chatBorder}`}>
                <ChatCard />
              </Paper>
            </Grid>
          </>
        )}
      </Grid>
      <RenewModal
        requestList={requestList}
        open={openRenewModal}
        fullWidth
        onClose={() => setOpenRenewModal(false)}
      />
      <ReviewModal
        requestList={requestList}
        open={openReviewModal}
        fullWidth
        onClose={() => setOpenReviewModal(false)}
      />
    </Container>
  )
}

export default RequestPage
